import type { BillingInfo } from '@/types/billing'
import { PB_SERVER_ADDR, pb } from './pocketbase'

export async function createCheckoutSession(
    planId: string,
    orgSlug: string
): Promise<{ url?: string; updated?: boolean }> {
    const response = await fetch(
        `${PB_SERVER_ADDR}/api/billing/create-checkout-session?orgSlug=${encodeURIComponent(orgSlug)}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: pb.authStore.token,
            },
            body: JSON.stringify({ planId }),
        }
    )

    if (!response.ok) {
        const error = await response.json()
        throw new Error(error.message || 'Failed to create checkout session')
    }

    return response.json()
}

export async function createPortalSession(orgSlug: string): Promise<{ url: string }> {
    const response = await fetch(
        `${PB_SERVER_ADDR}/api/billing/create-portal-session?orgSlug=${encodeURIComponent(orgSlug)}`,
        {
            method: 'POST',
            headers: {
                Authorization: pb.authStore.token,
            },
        }
    )

    if (!response.ok) {
        const error = await response.json()
        throw new Error(error.message || 'Failed to create portal session')
    }

    return response.json()
}

export async function getBillingInfo(orgSlug: string): Promise<BillingInfo> {
    const response = await fetch(
        `${PB_SERVER_ADDR}/api/billing/usage?orgSlug=${encodeURIComponent(orgSlug)}`,
        {
            headers: {
                Authorization: pb.authStore.token,
            },
        }
    )

    if (!response.ok) {
        const error = await response.json()
        throw new Error(error.message || 'Failed to get billing info')
    }

    return response.json()
}

export function formatPrice(cents: number): string {
    return `$${(cents / 100).toFixed(2)}`
}

export function isUnlimited(limit: number): boolean {
    return limit === -1
}

export function getUsagePercent(current: number, limit: number): number {
    if (isUnlimited(limit)) {
        return 0
    }
    return Math.min((current / limit) * 100, 100)
}

export function isAtLimit(current: number, limit: number): boolean {
    if (isUnlimited(limit)) {
        return false
    }
    return current >= limit
}
